<section class="pt-navigation-context">
  <div class="tabs-toggle-row">
    <dls-tabs class="pt-secondary-navigation">
      <a routerLink="/rules" routerLinkActive="pt-selected" [routerLinkActiveOptions]="{ exact: true }">
        <span>SRC Rules</span>
      </a>
      <a routerLink="/rules/rulesets" routerLinkActive="pt-selected">
        <span>Rulesets</span>
      </a>
      <a routerLink="/rules/reminder-sets" routerLinkActive="pt-selected">
        <span>Reminder Sets</span>
      </a>
      <ng-container *ngIf="showRulesBuilder">
        <a routerLink="/rules/rules-builder" routerLinkActive="pt-selected">
          <span>Rules Builder</span>
        </a>
      </ng-container>
    </dls-tabs>
    <div class="toggle-inline">
      <label class="toggle-label">Enable Rules Builder</label>
      <label class="switch">
        <input type="checkbox" [(ngModel)]="showRulesBuilder">
        <span class="slider round"></span>
      </label>
    </div>
  </div>
</section>

<!-- Nested Tabs for Rules -->
<div *ngIf="isRulesTabActive()" class="rules-inner-tabs-container" style="position:relative;">
  <dls-tabs class="pt-tertiary-navigation">
    <a routerLink="/rules/adherenceprofiler" routerLinkActive="pt-selected" [routerLinkActiveOptions]="{ exact: true }">
      <span>Adherence Profiler</span>
    </a>
    <a routerLink="/rules/compliance" routerLinkActive="pt-selected" [routerLinkActiveOptions]="{ exact: true }">
      <span>Compliance Rules</span>
    </a>
    <a routerLink="/rules/src-rules" routerLinkActive="pt-selected" [routerLinkActiveOptions]="{ exact: true }">
      <span>Rules Builder</span>
    </a>
  </dls-tabs>
</div>
<div class="rules-tab-content">
  <router-outlet></router-outlet>
</div>
